export default "__VITE_ASSET__QARyUoZh__"